
const shortHandUnits = {
    y: 24 * 60 * 60 * 1000 * 365,
    M: 24 * 60 * 60 * 1000 * 365/12,
    d: 24 * 60 * 60 * 1000,
    h: 60 * 60 * 1000,
    m: 60 * 1000,
    s: 1000
}

const longHandUnits = {
    year: 24 * 60 * 60 * 1000 * 365,
    month: 24 * 60 * 60 * 1000 * 365/12,
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000
}

export function formatRelativeTime(d1, d2 = new Date(), full) {
    const elapsed = d2 - d1;
    if (elapsed < 1000) return full ? "1 second" : "1s";
    const range = Math.abs(elapsed);
    const units = full ? longHandUnits : shortHandUnits;
    for (const u of Object.keys(units)) {
        if (range >= units[u] || u === 's') {
            const time = Math.round(elapsed / units[u]);
            return `${time}${full ? ' ' : ''}${u}${full && time !== 1 ? 's' : ''}`;
        }
    }
    return elapsed.toString();
}

export function nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
    }
}

export function formatDate(d) {

    const date = new Date(d);
    const day = nth(date.getDate());
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][date.getMonth()];

    return `${month} ${date.getDate()}${day}, ${date.getFullYear()}`;

}
